import { useEffect } from 'react';

/**
 * Sets the document title and meta description for the current page.
 *
 * This is a client-side render, so crawlers that do not run JavaScript still
 * see only the static index.html. That is a known limit of shipping this as a
 * CRA bundle on the NAS — the same one jpegs.me and tapes.me have. It is good
 * enough for a human following a shared link, and for the crawlers that do
 * execute JS; proper per-page link previews would need prerendering, which is
 * a separate piece of work.
 */
export const usePageMeta = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description.slice(0, 300));
    }
  }, [title, description]);
};
